import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useFormModal } from './FormModal';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const {
    openFormModal
  } = useFormModal();
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-185">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-0 left-0 right-0 p-4 bg-brand-dark/95 backdrop-blur-lg border-t border-white/10 z-50 lg:hidden" data-id="element-186">
          <button onClick={openFormModal} className="w-full bg-brand-cream text-brand-dark font-medium py-4 rounded-full active:scale-[0.98] transition-transform text-lg" data-id="element-187">
            Claim My $3,000 Off
          </button>
        </motion.div>}
    </AnimatePresence>;
}